import { ServerOption } from '../models/server-option';
import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';

export const serverOptionActions = createEagerSelectActions<ServerOption>('[Server Options]');
